import {BASE_URL} from "app/config/env";

const prefix = `${BASE_URL}/panel`;

export const projectEquipment = {
  'app.projectEquipment':     (pId=':projectId') =>  `${prefix}/projects/${pId}/equipment`
}
